module.exports = __webpack_public_path__ + "static/img/GT@3x.fd382044.jpg";